import React from "react";

const Header = () => {
  return (
    <div className="flex ml-[5px]">
      <span className="text-gray-500 font-medium ml-[4px] uppercase text-[18px]">
        📈 Product Movement
      </span>
    </div>
  );
};

export default Header;
